module.exports = __webpack_public_path__ + "media/images/sp/top/recommend-plan-text-maedori3-485a547783b2750cca2b52bb36ea66c0.png";